import React, { useCallback, useEffect } from 'react';
import Modal from 'antd/lib/modal';
import notification from 'antd/lib/notification';
import MDEditor from '@uiw/react-md-editor';

import config from 'config';
import { Job, JobStage, JobState } from 'cvat-core-wrapper';
import { t } from 'utils/i18n';

// Moved from the old right group so the guide still opens on first visit.
export function useGuide(jobInstance: Job, initialOpenGuide: boolean): () => void {
    const openGuide = useCallback(() => {
        const PADDING = Math.min(window.screen.availHeight, window.screen.availWidth) * 0.4;
        jobInstance.guide().then((guide) => {
            if (guide?.markdown) {
                Modal.info({
                    icon: null,
                    width: window.screen.availWidth - PADDING,
                    className: 'cvat-annotation-view-markdown-guide-modal',
                    content: React.createElement(MDEditor, {
                        visibleDragbar: false,
                        'data-color-mode': 'light',
                        height: window.screen.availHeight - PADDING,
                        preview: 'preview',
                        hideToolbar: true,
                        value: guide.markdown,
                    }),
                });
            }
        }).catch((error: unknown) => {
            notification.error({
                message: t('Could not receive annotation guide'),
                description: error instanceof Error ? error.message : String(error),
            });
        });
    }, [jobInstance]);

    useEffect(() => {
        if (Number.isInteger(jobInstance?.guideId)) {
            if (initialOpenGuide) {
                openGuide();
            } else if (
                jobInstance?.stage === JobStage.ANNOTATION &&
                jobInstance?.state === JobState.NEW
            ) {
                let seenGuides = [];
                try {
                    seenGuides = JSON.parse(localStorage.getItem('seenGuides') || '[]');
                    if (!Array.isArray(seenGuides) || seenGuides.some((el) => !Number.isInteger(el))) {
                        throw new Error('Wrong structure stored in local storage');
                    }
                } catch (error: unknown) {
                    seenGuides = [];
                }

                if (!seenGuides.includes(jobInstance.guideId)) {
                    // open guide if the user have not seen it yet
                    openGuide();
                    const updatedSeenGuides = Array
                        .from(new Set([
                            jobInstance.guideId,
                            ...seenGuides.slice(0, config.LOCAL_STORAGE_SEEN_GUIDES_MEMORY_LIMIT - 1),
                        ]));
                    localStorage.setItem('seenGuides', JSON.stringify(updatedSeenGuides));
                }
            }
        }
    }, []);

    return openGuide;
}
